import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { relativeTimeFormatter } from "@opensea/i18n";
import { Chip, classNames, Tooltip } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { getIsRecentlyCreatedCurrency } from "../../utils/currency";
import { NewCurrencyChipFragment } from "./NewCurrencyChip.fragment";
export function NewCurrencyChip(t0) {
  const $ = _c(11);
  const {
    className,
    currency: currencyKey
  } = t0;
  const currency = readFragment(NewCurrencyChipFragment, currencyKey);
  const isRecentlyCreated = currency ? getIsRecentlyCreatedCurrency(currency) : null;
  const formatRelativeTime = relativeTimeFormatter();
  const createdDate = currency?.genesisDate;
  const t = useTranslations("NewCurrencyChip");
  if (!(isRecentlyCreated && currency && createdDate)) {
    return null;
  }
  const T0 = Tooltip;
  const t1 = t("created", {
    date: formatRelativeTime(new Date(createdDate))
  });
  let t2;
  if ($[0] !== className) {
    t2 = classNames("border-success-1 text-success-1", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("new");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <Chip className={t2}>{t3}</Chip>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== T0 || $[8] !== t1 || $[9] !== t4) {
    t5 = <T0 content={t1}>{t4}</T0>;
    $[7] = T0;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}